/**
 * @generated SignedSource<<1c3d597fbd6ae2693a2f6eb9a45215c2>>
 * @relayHash 236e4ff617ceda8a59d38f1f95a9cb49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da742c69a28a3624cd1681b397b35f5f25d1173b7d4b326621070d2ab3fac6e1

import type { ConcreteRequest } from 'relay-runtime';
export type GoalCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type GoalCapabilitiesQuery$data = {
  readonly goals_capabilities?: {
    readonly canCreateGoal: boolean | null | undefined;
    readonly canExportGoals: boolean | null | undefined;
  } | null | undefined;
};
export type GoalCapabilitiesQuery = {
  response: GoalCapabilitiesQuery$data;
  variables: GoalCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          }
        ],
        "concreteType": "TownsquareGoalAppCapabilities",
        "kind": "LinkedField",
        "name": "goals_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateGoal"
          },
          {
            "kind": "ScalarField",
            "name": "canExportGoals"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "da742c69a28a3624cd1681b397b35f5f25d1173b7d4b326621070d2ab3fac6e1",
    "metadata": {},
    "name": "GoalCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e1ee56c4c6294f97811a0a0bc619fc30";

export default node;
